import { createReducer, on } from '@ngrx/store';
import * as SurveyTaskActions from './survey-tasks.actions';

export const surveyTasksFeatureKey = 'surveyTasks';

export interface SurveyTaskState {
  loading: boolean;
}

export const initialState: SurveyTaskState = {
  loading: true,
};

export const reducer = createReducer(
  initialState,
  on(SurveyTaskActions.deleteSurveyTask, (state, action) => state),
  on(SurveyTaskActions.clearSurveyTasks, (state) => initialState),
);
